"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.selectAppLocaleBranding = exports.toCredentialSummary = exports.getCredentialIssuerNameAndAlias = exports.getCredentialDisplayName = exports.getDate = exports.toNonPersistedCredentialSummary = void 0;
var uuid_1 = require("uuid");
var utils_1 = require("@veramo/utils");
var ui_components_core_1 = require("@sphereon/ui-components.core");
var ssi_sdk_core_1 = require("@sphereon/ssi-sdk.core");
var utils_2 = require("../utils");
function findCorrelationIdName(correlationId, parties, activeUser) {
    var _a, _b;
    var allParties = parties;
    if (activeUser) {
        parties.push(activeUser);
    }
    return ((_b = (_a = allParties === null || allParties === void 0 ? void 0 : allParties.find(function (contact) {
        return contact.identities.some(function (identity) { return identity.identifier.correlationId === correlationId; });
    })) === null || _a === void 0 ? void 0 : _a.contact.displayName) !== null && _b !== void 0 ? _b : correlationId);
}
var getImageSize = function (image) { return __awaiter(void 0, void 0, void 0, function () {
    var downloadedImage, imageSize, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, (0, ssi_sdk_core_1.downloadImage)(image)];
            case 1:
                downloadedImage = _b.sent();
                imageSize = undefined;
                _a = downloadedImage;
                if (!_a) return [3, 3];
                return [4, (0, utils_2.isImageAddress)(image)];
            case 2:
                _a = (_b.sent());
                _b.label = 3;
            case 3:
                if (!_a) return [3, 5];
                return [4, (0, ssi_sdk_core_1.getImageDimensions)(downloadedImage.base64Content)];
            case 4:
                imageSize = _b.sent();
                _b.label = 5;
            case 5: return [2, imageSize];
        }
    });
}); };
var toCredentialDetailsRow = function (_a) {
    var object = _a.object, subject = _a.subject, issuer = _a.issuer;
    return __awaiter(void 0, void 0, void 0, function () {
        var rows, _i, _b, _c, key, value, image, _d, _e, _f, _g, label, contacts, imageSize, _h;
        var _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    rows = [];
                    if (!object) {
                        return [2, rows];
                    }
                    _i = 0, _b = Object.entries(object);
                    _k.label = 1;
                case 1:
                    if (!(_i < _b.length)) return [3, 12];
                    _c = _b[_i], key = _c[0], value = _c[1];
                    if (!key) {
                        return [3, 11];
                    }
                    if (!key.toLowerCase().includes('image')) return [3, 3];
                    image = typeof value === 'string' ? value : value.id;
                    _e = (_d = rows).push;
                    _j = {
                        id: (0, uuid_1.v4)(),
                        label: 'image',
                        value: image
                    };
                    return [4, getImageSize(image)];
                case 2:
                    _e.apply(_d, [(_j.imageSize = _k.sent(),
                            _j)]);
                    return [3, 11];
                case 3:
                    if (key === 'type') {
                        rows.push({
                            id: (0, uuid_1.v4)(),
                            label: key,
                            value: value
                        });
                        return [3, 11];
                    }
                    _k.label = 4;
                case 4:
                    if (!(typeof value !== 'string' && value !== null && value !== undefined)) return [3, 6];
                    _g = (_f = rows).concat;
                    return [4, toCredentialDetailsRow({ object: value, subject: subject, issuer: issuer })];
                case 5:
                    rows = _g.apply(_f, [_k.sent()]);
                    return [3, 11];
                case 6:
                    if (key === '0' || value === undefined || value === null) {
                        return [3, 11];
                    }
                    label = key;
                    if (key === 'id' && value.startsWith('did:')) {
                        label = 'subject';
                    }
                    if (value.startsWith('did:')) {
                        contacts = __spreadArray(__spreadArray([], (issuer ? [issuer] : []), true), (subject ? [subject] : []), true);
                        value = findCorrelationIdName(value, contacts);
                    }
                    return [4, (0, utils_2.isImageAddress)(value)];
                case 7:
                    if (!(_k.sent())) return [3, 9];
                    return [4, getImageSize(value)];
                case 8:
                    _h = _k.sent();
                    return [3, 10];
                case 9:
                    _h = undefined;
                    _k.label = 10;
                case 10:
                    imageSize = _h;
                    rows.push({
                        id: (0, uuid_1.v4)(),
                        label: label,
                        value: value,
                        imageSize: imageSize
                    });
                    _k.label = 11;
                case 11:
                    _i++;
                    return [3, 1];
                case 12: return [2, rows];
            }
        });
    });
};
var toNonPersistedCredentialSummary = function (_a) {
    var verifiableCredential = _a.verifiableCredential, credentialRole = _a.credentialRole, branding = _a.branding, issuer = _a.issuer, subject = _a.subject;
    return (0, exports.toCredentialSummary)({
        verifiableCredential: verifiableCredential,
        hash: (0, utils_1.computeEntryHash)(verifiableCredential),
        credentialRole: credentialRole,
        branding: branding,
        issuer: issuer,
        subject: subject
    });
};
exports.toNonPersistedCredentialSummary = toNonPersistedCredentialSummary;
var getDate = function () {
    var dates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        dates[_i] = arguments[_i];
    }
    var date = dates === null || dates === void 0 ? void 0 : dates.find(function (date) { return date !== null && date !== undefined; });
    if (!date) {
        return;
    }
    else if (typeof date === 'number') {
        return date;
    }
    return Math.round(new Date(date + '').valueOf() / ui_components_core_1.EPOCH_MILLISECONDS);
};
exports.getDate = getDate;
var getCredentialDisplayName = function (_a) {
    var _b, _c;
    var verifiableCredential = _a.verifiableCredential, localeBranding = _a.localeBranding;
    var title = (_c = (_b = localeBranding === null || localeBranding === void 0 ? void 0 : localeBranding.alias) !== null && _b !== void 0 ? _b : verifiableCredential.name) !== null && _c !== void 0 ? _c : (!verifiableCredential.type ? 'unknown' : undefined);
    if (verifiableCredential.type) {
        var types = (0, utils_1.asArray)(verifiableCredential.type).filter(function (val) { return val !== 'VerifiableCredential'; });
        if (types.length === 1) {
            title = types[0];
        }
        else if (types.length > 1) {
            title = types.join(', ');
        }
    }
    if (!title) {
        title = 'Credential';
    }
    return title;
};
exports.getCredentialDisplayName = getCredentialDisplayName;
var getCredentialIssuerNameAndAlias = function (_a) {
    var _b;
    var verifiableCredential = _a.verifiableCredential, issuer = _a.issuer;
    var issuerName = typeof verifiableCredential.issuer === 'string' ? verifiableCredential.issuer : (_b = verifiableCredential.issuer) === null || _b === void 0 ? void 0 : _b.id;
    var issuerAlias = undefined;
    if (typeof (verifiableCredential === null || verifiableCredential === void 0 ? void 0 : verifiableCredential.issuer) === 'object') {
        issuerAlias = verifiableCredential.issuer.name;
    }
    if (!issuerAlias && issuer) {
        issuerAlias = issuer.contact.displayName;
    }
    if (!issuerAlias) {
        issuerAlias = issuerName;
    }
    return { issuerName: issuerName, issuerAlias: issuerAlias };
};
exports.getCredentialIssuerNameAndAlias = getCredentialIssuerNameAndAlias;
var getTermsOfUse = function (_a) {
    var verifiableCredential = _a.verifiableCredential;
    if (!verifiableCredential.termsOfUse) {
        return;
    }
    var termsOfUse = (0, utils_1.asArray)(verifiableCredential.termsOfUse);
    return termsOfUse.map(function (tou) {
        var _a;
        var type = tou.type, id = tou.id, rest = __rest(tou, ["type", "id"]);
        return __assign((_a = {}, _a[type] = id, _a), rest);
    });
};
var toCredentialSummary = function (_a) {
    var verifiableCredential = _a.verifiableCredential, hash = _a.hash, credentialRole = _a.credentialRole, branding = _a.branding, issuer = _a.issuer, subject = _a.subject;
    return __awaiter(void 0, void 0, void 0, function () {
        var expirationDate, issueDate, localeBranding, credentialStatus, title, properties, logo, url, _b, issuerName, issuerAlias, termsOfUse;
        var _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    expirationDate = (_c = (0, exports.getDate)(verifiableCredential.expirationDate, verifiableCredential.validTo, verifiableCredential.exp)) !== null && _c !== void 0 ? _c : 0;
                    issueDate = (0, exports.getDate)(verifiableCredential.issuanceDate, verifiableCredential.validFrom, verifiableCredential.nbf, verifiableCredential.iat);
                    return [4, (0, exports.selectAppLocaleBranding)({ localeBranding: branding })];
                case 1:
                    localeBranding = _e.sent();
                    credentialStatus = (0, utils_2.getCredentialStatus)(verifiableCredential);
                    title = (0, exports.getCredentialDisplayName)({ verifiableCredential: verifiableCredential, localeBranding: localeBranding });
                    return [4, toCredentialDetailsRow({
                            object: __assign(__assign({}, (_d = verifiableCredential.vc) === null || _d === void 0 ? void 0 : _d.credentialSubject), verifiableCredential.credentialSubject),
                            subject: subject,
                            issuer: issuer
                        })];
                case 2:
                    properties = _e.sent();
                    logo = (0, utils_2.getIssuerLogo)(verifiableCredential, localeBranding);
                    url = typeof verifiableCredential.issuer !== 'string' ? verifiableCredential.issuer.url : undefined;
                    _b = (0, exports.getCredentialIssuerNameAndAlias)({ verifiableCredential: verifiableCredential, issuer: issuer }), issuerName = _b.issuerName, issuerAlias = _b.issuerAlias;
                    termsOfUse = getTermsOfUse({ verifiableCredential: verifiableCredential });
                    return [2, {
                            hash: hash,
                            id: verifiableCredential.id,
                            title: title,
                            credentialStatus: credentialStatus,
                            credentialRole: credentialRole,
                            issueDate: issueDate,
                            expirationDate: expirationDate,
                            properties: properties,
                            branding: localeBranding,
                            termsOfUse: termsOfUse,
                            issuer: {
                                name: issuerName,
                                alias: issuerAlias ? (issuerAlias.length > 50 ? "".concat(issuerAlias.substring(0, 50), "...") : issuerAlias) : '',
                                image: logo,
                                url: url
                            }
                        }];
            }
        });
    });
};
exports.toCredentialSummary = toCredentialSummary;
var selectAppLocaleBranding = function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var appLocale, localeBranding, logo, imagePreloader, ReactNativeImagePreloader, WebImagePreloader, backgroundImage;
    var _a, _b, _c, _d, _e, _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                appLocale = ui_components_core_1.Localization.getLocale();
                localeBranding = (_a = args.localeBranding) === null || _a === void 0 ? void 0 : _a.find(function (branding) { var _a; return ((_a = branding.locale) === null || _a === void 0 ? void 0 : _a.startsWith(appLocale)) || branding.locale === undefined; });
                logo = ((_b = localeBranding === null || localeBranding === void 0 ? void 0 : localeBranding.logo) === null || _b === void 0 ? void 0 : _b.dataUri) || ((_c = localeBranding === null || localeBranding === void 0 ? void 0 : localeBranding.logo) === null || _c === void 0 ? void 0 : _c.uri);
                if (!(typeof window === 'undefined')) return [3, 2];
                return [4, Promise.resolve().then(function () { return __importStar(require('../services/ReactNativeImagePreloader')); })];
            case 1:
                ReactNativeImagePreloader = (_h.sent()).ReactNativeImagePreloader;
                imagePreloader = new ReactNativeImagePreloader();
                return [3, 4];
            case 2: return [4, Promise.resolve().then(function () { return __importStar(require('../services/WebImagePreloader')); })];
            case 3:
                WebImagePreloader = (_h.sent()).WebImagePreloader;
                imagePreloader = new WebImagePreloader();
                _h.label = 4;
            case 4:
                if (logo) {
                    imagePreloader.preload([{ uri: logo }])["catch"](function () {
                    });
                }
                backgroundImage = ((_e = (_d = localeBranding === null || localeBranding === void 0 ? void 0 : localeBranding.background) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.dataUri) || ((_g = (_f = localeBranding === null || localeBranding === void 0 ? void 0 : localeBranding.background) === null || _f === void 0 ? void 0 : _f.image) === null || _g === void 0 ? void 0 : _g.uri);
                if (backgroundImage) {
                    imagePreloader.preload([{ uri: backgroundImage }])["catch"](function () {
                    });
                }
                return [2, localeBranding];
        }
    });
}); };
exports.selectAppLocaleBranding = selectAppLocaleBranding;
